import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-no-id-dialog',
  templateUrl: './no-id-dialog.component.html',
  styleUrls: ['./no-id-dialog.component.scss']
})
export class NoIdDialogComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal
    , private router: Router) { }

  ngOnInit() {
  }

  dismiss() {
    this.activeModal.close({ result: false });
  }

  goToNewRequest() {
    this.router.navigate(['questionnaire', 'user-details', '1']);
    this.dismiss();
  }

  back() {
    console.log("Back!");
    this.dismiss();
  }

  openChat() {
    console.log("CHAT!");
  }
}



// WEBPACK FOOTER //
// ./src/app/no-id-dialog/no-id-dialog.component.ts